import { render, staticRenderFns } from "./Form2316.vue?vue&type=template&id=32f9a66c&scoped=true"
import script from "./Form2316.vue?vue&type=script&lang=js"
export * from "./Form2316.vue?vue&type=script&lang=js"
import style0 from "./Form2316.vue?vue&type=style&index=0&id=32f9a66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9a66c",
  null
  
)

export default component.exports